import type { RootState } from "../../store/store";

export const selectTenantState = (state: RootState) => state.tenant;

export const selectLocalTenantHost = (state: RootState) => selectTenantState(state).localTenantHost;

export const selectCurrentSiteConfig = (state: RootState) =>
  selectTenantState(state).currentSiteConfig;

export const selectTenantId = (state: RootState) => selectCurrentSiteConfig(state)?.tenantId;
